import { MP_OPENID_BASE_KEY, scopedAssetKey } from './assetStorageScope';

function openidKey() {
  return scopedAssetKey(MP_OPENID_BASE_KEY);
}

export function getMpOpenid() {
  try {
    return String(window.localStorage.getItem(openidKey()) || '').trim();
  } catch (error) {
    return '';
  }
}

export function setMpOpenid(value) {
  const openid = String(value || '').trim();
  if (!openid) return false;
  try {
    window.localStorage.setItem(openidKey(), openid);
    return true;
  } catch (error) {
    return false;
  }
}

export function clearMpOpenid() {
  try {
    window.localStorage.removeItem(openidKey());
  } catch (error) {
    // ignore
  }
}

export function maskMpOpenid(openid) {
  const text = String(openid || '').trim();
  if (!text) return '';
  if (text.length <= 8) return `${text.slice(0, 2)}****`;
  return `${text.slice(0, 6)}****${text.slice(-4)}`;
}
